var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContentHeading',{attrs:{"heading":_vm.heading}}),_c('ContentList',{attrs:{"contents":_vm.content,"tenant-url":_vm.tenantUrl,"parent-group-id":_vm.parentGroupId,"is-desktop":_vm.isDesktop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }